<template>
    <div class="row">
        <div class="col-lg-12">
            <h1 class="page-header">Minhas Ações</h1>

            <!-- Lista de compromissos -->
            <div class="col-xs-12">
                <list 
                    ref="vuetable" 
                    :show-empty="true" 
                    api-url="planogoverno/compromisso-acao-profile"
                    report-title="Minhas Ações" 
                    :fields="fields" 
                    :initial-page="pagina"
                    :pageCollection="'minhasAcoes'"
                    :append-params="filtros"
                    @load-sucesso="ordernarAcoesPendentesPrimeiro"
                >
                    <template slot="filters">
                        <div class="collapse" id="filtros">
                            <!-- Filtro por descritivo -->
                            <div class="col-sm-6">
                                <label for="descritivo_filter" class="custom-font">Descritivo</label>
                                <input 
                                    type="text" 
                                    v-model="descritivo" 
                                    @change="consultar"
                                    ref="descritivo_filter"
                                    name="descritivo_filter"
                                    class="form-control"
                                    placeholder="Buscar por descrição" 
                                />
                            </div>

                            <!-- Filtro por status -->
                            <div class="col-sm-6">
                                <label for="status-filter" class="custom-font">Status</label>
                                <div class="custom-select">
                                    <select 
                                        v-model="status" 
                                        @change="consultar"
                                        ref="status_filter" 
                                        name="status_filter"
                                        class="form-control select-selected"
                                    >
                                        <option value='' selected>
                                            Todos
                                        </option>
                                        <option v-for="status in listas.status" :key="status" :value="status">
                                            {{ status }}
                                        </option>
                                    </select>
                                </div>
                            </div>


                            <!-- Filtro buttons -->
                            <div class="col-xs-12">
                                <button @click="consultar()" class="btn btn-default margem-topo"
                                    name="btnFiltrar">
                                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                                    Filtrar
                                </button>
                                <button @click="limpar()" class="btn btn-default margem-topo" name="btnLimpar">
                                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                                    Limpar Filtros
                                </button>
                            </div>
                        </div>
                    </template>

                    <template slot="actions">
                        <button class="btn btn-default" data-toggle="collapse" data-target="#filtros">
                            <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
                        </button>
                    </template>

                    <template slot="rowrender" slot-scope="props">
                        <div
                            v-if="props.rowData.unidade === props.rowData.unidade_executora 
                                || actionState(props.rowData.id)"
                        >
                            <button 
                                title="Informações" 
                                type="button" 
                                class="btn btn-primary"
                                @click="detalhar(props.rowData)"
                            >
                                <font-awesome-icon :icon="'info'" class="icon" />
                            </button>
                            <button
                                title="Iniciar ação"
                                type="button"
                                class="btn btn-primary"
                                :disabled="props.rowData.status !== 'Não Iniciado'"
                                @click="iniciar(props.rowData)"
                            >
                                <font-awesome-icon :icon="'calendar'" class="icon" />
                            </button>
                            <button 
                                title="Concluir ação" 
                                type="button"
                                :disabled="props.rowData.status !== 'Em andamento'"
                                class="btn btn-primary" 
                                @click="concluir(props.rowData)"
                            >
                                <font-awesome-icon :icon="'check'" class="icon" />
                            </button>
                            <button
                                :title="props.rowData.unidade === props.rowData.unidade_executora ? 'Cancelar' : 'Rejeitar'"
                                type="button"
                                :disabled="props.rowData.status === 'Cancelada' 
                                    || props.rowData.status === 'Rejeitada' 
                                    || props.rowData.status === 'Concluído'"
                                class="btn btn-danger" @click="cancelar(props.rowData)">
                                <font-awesome-icon :icon="'times'" class="icon" />
                            </button>
                        </div>
                        <div v-else>
                            <button 
                                title="Aceitar" 
                                type="button" 
                                class="button button-success"
                                @click="saveActionState(props.rowData, 'Aceitar')"
                            >
                                Aceitar
                            </button>
                            <button 
                                title="Rejeitar" 
                                type="button" 
                                class="button button-danger"
                                @click="saveActionState(props.rowData, 'Rejeitar')"
                            >
                                Rejeitar
                            </button>
                        </div>
                    </template>
                </list>
            </div>

            <!-- Modal para justificar cancelamento -->
            <div v-if="modalCancelar.visivel" class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <h4 class="modal-title">
                            Justifique {{ 
                            modalCancelar.acao.unidade === modalCancelar.acao.unidade_executora 
                            ? 'o cancelamento' : 'a rejeição' 
                            }}
                        </h4>

                        <p><strong>Compromisso:</strong> {{ modalCancelar.compromisso.descritivo }}</p>

                        <p><strong>Ação:</strong> {{ modalCancelar.acao.descritivo }}</p>

                        <textarea 
                            v-model="modalCancelar.justificativa" 
                            class="form-control" 
                            cols="40"
                            rows="5"
                        ></textarea>

                        <div class="modal-footer">
                            <button 
                                class="btn btn-success" 
                                :disabled="!modalCancelar.justificativa.trim()"
                                @click="cancelarAcao(modalCancelar.acao)"
                            >
                                Salvar
                            </button>
                            <button class="btn btn-default" @click="fecharModalCancelar">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal para aceitar ação de uma secretária externa -->
            <div v-if="modalAceitar.visivel" class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <h4 class="modal-title">
                            Defina a data de início e a data estimada de conclusão
                        </h4>

                        <p><strong>Compromisso:</strong> {{ modalAceitar.compromisso.descritivo }}</p>

                        <p><strong>Ação:</strong> {{ modalAceitar.acao.descritivo }}</p>

                        <div class="modal-form">
                            <div class="col-xs-12 col-sm-12 ">
                                <label class="control-label custom-font">Data de início</label>
                                <div class="inputgroupcontainer">
                                    <div class="input-group">
                                        <span class="input-group-addon">
                                            <font-awesome-icon :icon="'calendar-alt'" class="icon" />
                                        </span>
                                        <datepicker v-model="modalAceitar.data_estimada_inicio" />
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-12">
                                <label class="control-label custom-font">Data estimada de conclusão</label>
                                <div class="inputgroupcontainer">
                                    <div class="input-group">
                                        <span class="input-group-addon">
                                            <font-awesome-icon :icon="'calendar-alt'" class="icon" />
                                        </span>
                                        <datepicker v-model="modalAceitar.data_estimada_conclusao" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button 
                                class="btn btn-success" 
                                :disabled="!modalAceitar.data_estimada_inicio || !modalAceitar.data_estimada_conclusao" 
                                @click="aceitarAcao(modalAceitar.acao)"
                            >
                                Salvar
                            </button>
                            <button class="btn btn-default" @click="fecharModalAceitar">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>

            <SideAcao
                ref="side"
                :navs="sideConfig"
                @concluir="concluirAcao"
                @iniciar="iniciarAcao"
            />
        </div>
    </div>
</template>

<script>
import list from '@/components/common/DataTable'
import datepicker from '@/components/common/Datepicker'
import SideAcao from '@/components/planogoverno/SideAcao.vue'
import { request } from '@/request'

export default {
    components: { list, datepicker, SideAcao },
    data() {
        return {
            fields: [
                {
                    name: 'unidade_executora',
                    title: 'Unidade Executora',
                    sortField: 'unidade_executora',
                    dataClass: 'align-middle',
                    filterable: true
                },
                {
                    name: 'descritivo',
                    title: 'Descritivo',
                    sortField: 'descritivo',
                    dataClass: 'align-middle truncate-multiline',
                    filterable: true,
                    callback(value) {
                        if (!value) return ''
                        return value.length > 150 ? value.substring(0, 97) + '...' : value
                    }
                },
                {
                    name: 'data_estimada_inicio',
                    title: 'Inicia',
                    sortField: 'data_estimada_inicio',
                    titleClass: 'text-center',
                    dataClass: 'text-center align-middle',
                    filterable: true
                },
                {
                    name: 'data_estimada_conclusao',
                    title: 'Finaliza',
                    sortField: 'data_estimada_conclusao',
                    titleClass: 'text-center',
                    dataClass: 'text-center align-middle',
                    filterable: true
                },
                {
                    name: 'status',
                    title: 'Status',
                    sortField: 'status',
                    titleClass: 'text-center',
                    dataClass: 'text-center align-middle',
                    filterable: true
                },
                {
                    name: '__slot:actions',
                    title: 'Ações',
                    titleClass: 'text-center col-md-3',
                    dataClass: 'text-center'
                }
            ],     
            listas: {
                secretarias: [],
                autarquias: [],
                status: ['Não Iniciado', 'Em andamento', 'Concluído', 'Cancelada', 'Rejeitada']
            },
            modalCancelar: {
                visivel: false,
                acao: null,
                compromisso: null,
                justificativa: ''
            },
            modalAceitar: {
                visivel: false,
                acao: null,
                compromisso: null,
                data_inicio: null,
                data_estimada_conclusao: null,
            },
            sideConfig: [
                {
                    titulo: 'Concluir',
                    subtitulo: '',
                    subtDetalhe: '',
                    largura: 900,
                    identidade: 'concluir',
                    abreProximo: false,
                    aberto: false,
                    data: null
                },
                {
                    titulo: 'Iniciar',
                    subtitulo: '',
                    subtDetalhe: '',
                    largura: 900,
                    identidade: 'iniciar',
                    abreProximo: false,
                    aberto: false,
                    data: null
                },
                {
                    titulo: 'Detalhes',
                    subtitulo: '',
                    subtDetalhe: '',
                    largura: 900,
                    identidade: 'detalhes',
                    abreProximo: false,
                    aberto: false,
                    data: null
                }
            ],
            acao: null,
            responsaveisCache: {}
        }
    },
    computed: {
        filtros() {
            return{
                descritivo: this.descritivo,
                status: this.status
            }
        },
        pagina: {
            get() {
                const { minhasAcoes } = this.$store.state.vuetableState
                const { pagina } = minhasAcoes
                return pagina
            },
            set(value) {
                this.$store.commit('SET_FILTER_PAGE', {
                    collection: 'minhasAcoes',
                    value
                })
            }
        },
        descritivo: {
            get() {
                return (
                this.$store.state.vuetableState
                    .minhasAcoes
                    .filtros
                    .descritivo
                || ''
                )
            },
            set(value) {
                this.$store.commit('SET_FILTER_FIELD', {
                    field: 'descritivo',
                    collection: 'minhasAcoes',
                    value: value
                })
                this.resetPageStore()
            }
        },
        status: {
            get() {
                return (
                this.$store.state.vuetableState
                    .minhasAcoes
                    .filtros
                    .status
                || ''
                )
            },
            set(value) {
                this.$store.commit('SET_FILTER_FIELD', {
                    field: 'status',
                    collection: 'minhasAcoes',
                    value: value
                })
                this.resetPageStore()
            }
        }
    },
    methods: {
        async saveActionState(acao, status) {
            if (status === 'Aceitar') {
                this.aceitar(acao)
            }
            else if (status === 'Rejeitar') {
                this.cancelar(acao)
            }
        },
        async obterNomeResponsavel(sshd) {
            if (this.responsaveisCache[sshd]) {
                return this.responsaveisCache[sshd]
            }

            try {
                const responsaveis = await this.loadResponsaveis([sshd]);
                const nome = responsaveis[0] ? responsaveis[0].nome : 'Não encontrado';
                
                this.responsaveisCache[sshd] = nome;

                return nome;
            } catch (err) {
                console.error("Erro ao obter nome do responsável:", err)
                this.$toastr.e("Erro ao obter nome do responsável.")
                return sshd
            }
        },
        async loadResponsaveis(listaSSHD) {
            if (!listaSSHD || listaSSHD.length === 0) return [];
            try {
                const { status, data } = await request.get(`/funcionario?sshds=${listaSSHD.join(',')}`);
                if (status !== 200) return [];
                return data;
            } catch (err) {
                console.error('Erro ao carregar responsáveis:', err);
                return [];
            }
        },
        async carregarCompromisso(acao) {
            try {
                const { data } = await request.get(`planogoverno/compromisso/${acao.compromisso_id}`)
                const { descritivo, periodo, status } = data
    
                return {
                    descritivo,
                    periodo,
                    status
                }
            } catch (err) {
                console.error("Erro ao carregar compromisso:", err)
                this.$toastr.e("Erro ao carregar compromisso.")
                return null
            }
        },
        actionState(id) {
            const objeto = JSON.parse(localStorage.getItem('acaoPerfil'))
            return objeto && objeto.state.includes(id)
        },
        isAcaoPendente(acao) {
            return acao.unidade !== acao.unidade_executora && !this.actionState(acao.id);
        },
        ordernarAcoesPendentesPrimeiro(response) {
            if (!response || !response.data || !response.data.data) return;

            const acoes = response.data.data;
            
            const ordenado = [...acoes].sort((a, b) => {
                const aPendente = this.isAcaoPendente(a);
                const bPendente = this.isAcaoPendente(b);

                if (aPendente && !bPendente) return -1;
                if (!aPendente && bPendente) return 1;
                return 0;
            })

            response.data.data = ordenado;
        },
        async detalhar(acao) {
            this.sideConfig[2].subtitulo = acao.descritivo
            acao.nome_responsavel = await this.obterNomeResponsavel(acao.sshd_responsavel);
            this.sideConfig[2].data = acao

            try {
                const compromisso = await this.carregarCompromisso(acao);
                this.sideConfig[2].data.compromisso = compromisso;
            } catch (error) {
                console.error("Erro ao carregar o compromisso:", error);
                this.$toastr.e("Erro ao carregar o compromisso.");
                this.sideConfig[2].data.compromisso = null;
            }

            this.$refs.side.$emit('abreModal', 'detalhes')
        },
        async concluir(acao) {
            this.sideConfig[0].subtitulo = acao.descritivo
            acao.nome_responsavel = await this.obterNomeResponsavel(acao.sshd_responsavel);
            this.sideConfig[0].data = acao
            
            this.$refs.side.$emit('abreModal', 'concluir')
        },
        async iniciar(acao) {
            this.sideConfig[1].subtitulo = acao.descritivo
            acao.nome_responsavel = await this.obterNomeResponsavel(acao.sshd_responsavel);
            this.sideConfig[1].data = acao

            this.$refs.side.$emit('abreModal', 'iniciar')
        },
        async concluirAcao(acaoId) {
            const { status } = await request.put(`planogoverno/compromisso-acao/${acaoId}`, {
                status: 'Concluído',
                data_conclusao: this.formatDate(new Date())
            })

            if (status !== 200) return this.$toastr.e('Erro ao concluir a ação.')

            this.$toastr.s('Ação concluída com sucesso!')
            this.$refs.vuetable.refresh()
            
            this.$refs.side.$emit('fechaModal', 'concluir')
        },
        async iniciarAcao(acaoId) {
            const { status } = await request.put(`planogoverno/compromisso-acao/${acaoId}`, {
                status: 'Em andamento',
                data_inicio: this.formatDate(new Date())
            })

            if (status !== 200) return this.$toastr.e('Erro ao iniciar a ação.')

            this.$toastr.s('Ação iniciada com sucesso!')
            this.$refs.vuetable.refresh()

            this.$refs.side.$emit('fechaModal', 'iniciar')
        },
        fecharSide() {
            this.$refs.side.$emit('fechaModal', 'detalhes')
        },
        formatDate(date) {
            const year = date.getFullYear()
            const month = ('0' + (date.getMonth() + 1)).slice(-2)
            const day = ('0' + date.getDate()).slice(-2)
            const hour = ('0' + date.getHours()).slice(-2)
            const minute = ('0' + date.getMinutes()).slice(-2)
            const second = ('0' + date.getSeconds()).slice(-2)

            return `${year}-${month}-${day} ${hour}:${minute}:${second}`
        },
        async cancelar(acao) {
            this.modalCancelar.acao = acao

            try {
                const compromisso = await this.carregarCompromisso(acao)
                this.modalCancelar.compromisso = compromisso
            } catch (err) {
                console.error("Erro ao carregar o compromisso:", err)
                this.$toastr.e("Erro ao carregar o compromisso.")
                this.modalCancelar.compromisso = null
            }

            this.modalCancelar.visivel = true
        },
        async aceitar(acao) {
            this.modalAceitar.acao = acao

            try {
                const compromisso = await this.carregarCompromisso(acao)
                this.modalAceitar.compromisso = compromisso
            } catch (err) {
                console.error("Erro ao carregar o compromisso:", err)
                this.$toastr.e("Erro ao carregar o compromisso.")
                this.modalAceitar.compromisso = null
            }

            this.modalAceitar.visivel = true
        },
        fecharModalCancelar() {
            this.modalCancelar.visivel = false
            this.modalCancelar.acao = null
            this.modalCancelar.compromisso = null
            this.modalCancelar.justificativa = ''
        },
        fecharModalAceitar() {
            this.modalAceitar.visivel = false
            this.modalAceitar.acao = null
            this.modalAceitar.compromisso = null
            this.modalAceitar.data_estimada_inicio = null
            this.modalAceitar.data_estimada_conclusao = null
        },
        async cancelarAcao(acao) {
            const novoStatus = acao.unidade === acao.unidade_executora
                ? 'Cancelada'
                : 'Rejeitada';

            const { status } = await request.put(
                `planogoverno/compromisso-acao-profile/${acao.id}`,
                {
                    justificativa_rejeicao: this.modalCancelar.justificativa,
                    status: novoStatus
                }
            )

            if (status != 200) return this.$toastr.e('Erro ao cancelar a ação.')

            let objeto = JSON.parse(localStorage.getItem('acaoPerfil')) || { state: [] };
            if (!objeto.state.includes(acao.id)) {
                objeto.state.push(acao.id);
                localStorage.setItem('acaoPerfil', JSON.stringify(objeto));
            }

            this.$toastr.s('Ação cancelada com sucesso!')
            this.$refs.vuetable.refresh()
            this.fecharModalCancelar()
        },
        async aceitarAcao(acao) {
            if (!this.validateDates()) {
                return
            }

            if (this.modalAceitar.data_estimada_inicio) {
                this.modalAceitar.data_estimada_inicio = (this.modalAceitar.data_estimada_inicio instanceof Date)
                    ? this.formatdate(this.modalAceitar.data_estimada_inicio)
                    : this.formatdate(new Date(this.modalAceitar.data_estimada_inicio))
            }

            if (this.modalAceitar.data_estimada_conclusao) {
                this.modalAceitar.data_estimada_conclusao = (this.modalAceitar.data_estimada_conclusao instanceof Date)
                    ? this.formatdate(this.modalAceitar.data_estimada_conclusao)
                    : this.formatdate(new Date(this.modalAceitar.data_estimada_conclusao))
            }

            try {
                const { status } = await request.put(
                    `planogoverno/compromisso-acao/${acao.id}`,
                    {
                        data_inicio: this.modalAceitar.data_estimada_inicio,
                        data_estimada_conclusao: this.modalAceitar.data_estimada_conclusao
                    }
                )

                if (status != 200) return this.$toastr.e('Erro ao aceitar a ação.')
            } catch (err) {
                console.error('Erro ao aceitar a ação: ', err.response.data)
                return this.$toastr.e('Erro ao aceitar a ação.')
            }

            let objeto = JSON.parse(localStorage.getItem('acaoPerfil')) || { state: [] };
            if (!objeto.state.includes(acao.id)) {
                objeto.state.push(acao.id);
                localStorage.setItem('acaoPerfil', JSON.stringify(objeto));
            }

            this.$toastr.s('Ação aceita com sucesso!')
            this.$refs.vuetable.refresh()
            this.fecharModalAceitar()
        },
        validateDates() {
            if (this.modalAceitar.data_estimada_inicio && this.modalAceitar.data_estimada_conclusao) {
                const inicio = new Date(this.modalAceitar.data_estimada_inicio)
                const termino = new Date(this.modalAceitar.data_estimada_conclusao)
                if (termino < inicio) {
                    this.$toastr.e("A data prevista de conclusão não pode ser menor que a data de início")
                    return false
                }
            }
            return true
        },
        formatdate(date) {
            const year = date.getFullYear()
            const month = ('0' + (date.getMonth() + 1)).slice(-2)
            const day = ('0' + date.getDate()).slice(-2)
            const hour = ('0' + date.getHours()).slice(-2)
            const minute = ('0' + date.getMinutes()).slice(-2)
            const second = ('0' + date.getSeconds()).slice(-2)

            return `${year}-${month}-${day} ${hour}:${minute}:${second}`
        },
        consultar() {
            this.$nextTick(() => {
                this.$refs.vuetable.refresh()
            })
        },
        limpar() {
            this.descritivo = ''
            this.status = ''

            this.$refs.vuetable.refresh()
        },
        resetPageStore() {
            this.$store.commit('SET_FILTER_PAGE', {
                collection: 'minhasAcoes',
                value: 1
            })
        }
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 100%;
    max-width: 500px;
    margin: 0px auto;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    font-family: 'Helvetica Neue', Arial, sans-serif;
    overflow: visible;
}

.modal-title {
    margin-top: 0;
    color: #00615c;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e5e5e5;
}

.modal-form>div {
    margin: 15px 0;
}

.modal-footer {
    margin-top: 15px;
    text-align: right;
    border-top: 1px solid #e5e5e5;
}

.custom-font {
    font-size: 16px;
    color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}

.icon {
    min-width: 14px;
}

.button {
    display: inline-block;
    margin-bottom: 0;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    border-radius: 4px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.button-danger {
    background-color: #dc3545;
    border-color: #dc3545;
    color: #fff;
    text-transform: uppercase;
}

.button-danger:hover {
    background-color: #c82333;
    border-color: #bd2130;
    color: #fff;
}

.button-success {
    background-color: #28a745;
    border-color: #28a745;
    color: #fff;
    text-transform: uppercase;
}

.button-success:hover {
    background-color: #218838;
    border-color: #1e7e34;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/plano-governo/acao/MinhasAcoes.vue